import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0885a83f&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"
import style0 from "./Header.vue?vue&type=style&index=0&id=0885a83f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0885a83f",
  null
  
)

export default component.exports